<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Αιτήσεις</h4>
          <p class="card-title-desc">Διαχείριση αιτήματα αδειών</p>

          <div class="row">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <!-- <div class="col-sm-12 col-md-6"></div> -->
                    <div class="col-sm-12 col-md-12">
                      <div v-if="is_tree" id="tickets-table_filter" class="dataTables_filter ">
                        <label class="d-inline-flex align-items-center">
                          Τμήματα:
                        </label>

                        <multiselect placeholder="Επιλογή τμημάτων" track-by="id" label="name"
                          :options="departmentNames" :multiple="true" v-model="departmentValue"
                          selectLabel="Eπιλογή Τμήματος" selectedLabel="Επιλέχθηκε" deselectLabel="Αποεπιλογή">
                        </multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-sm-12 col-md-4">
                      <div id="tickets-table_filter" class="dataTables_filter ">
                        <label class="d-inline-flex align-items-center">
                          Ρόλοι:

                          <multiselect placeholder="Επιλογή Ρόλων" :options="roleOptions" track-by="id" label="name"
                            :multiple="true" v-model="roleValue" selectLabel="Eπιλογή Ρόλου" selectedLabel="Επιλέχθηκε"
                            deselectLabel="Αποεπιλογή"></multiselect>
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-7 col-md-4">
                      <div id="tickets-table_filter" class="dataTables_filter text-md">
                        <label class="d-inline-flex align-items-center">
                          Σχέση Εργασίας:

                          <multiselect placeholder="Επιλογή Σχέσης εργασίας" :options="employmentRelationShips"
                            track-by="id" label="title" :multiple="true" v-model="relationShipValue"
                            selectLabel="Eπιλογή Σχέσης εργασίας" selectedLabel="Επιλέχθηκε" deselectLabel="Αποεπιλογή">
                          </multiselect>
                        </label>
                      </div>
                    </div>

                    <div class="col-sm-12 col-md-4">
                      <div id="tickets-table_filter" class="dataTables_filter text-md-center">
                        <label class="d-inline-flex align-items-center">
                          Αναζήτηση:
                          <b-input-group>
                            <b-form-input v-model="searchFilter" type="search" class="form-control form-control-sm ms-2"
                              @keyup.enter="onSearchPerson"></b-form-input>
                            <b-input-group-append>
                              <b-button v-if="searchFilter.length > 0" variant="danger"
                                @click.prevent="onClearSearchPerson">
                                <i class="bx bx-x"></i>
                              </b-button>
                              <b-button variant="primary" @click.prevent="onSearchPerson">
                                <i class="bx bx-search-alt-2"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                          <div class="btn-group btn-group-sm" role="group">
                            <!-- <b-button
                                  variant="primary"
                                  @click.prevent="onSearchPerson"
                                >
                                  <i class="bx bx-search-alt-2"></i>
                                </b-button> -->
                          </div>
                        </label>
                      </div>
                    </div>

                    <!-- Table -->
                    <div class="table-responsive">
                      <table class="table mb-0">
                        <thead class="table-light">
                          <tr>
                            <th>Α/Α</th>
                            <th>Ονοματεπώνυμο</th>
                            <th>Τμήμα</th>
                            <th>Ρόλος</th>
                            <th>Σχέση Εργασίας</th>
                            <th>Ημερομηνία αίτησης</th>
                            <th>Διάστημα</th>
                            <th>Μέρες</th>
                            <th>Τύπος</th>
                            <th>Κατάσταση</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-if="
                          holidayRequests &&
                          holidayRequests.results &&
                          holidayRequests.results.length > 0
                        ">
                          <tr v-for="(holidayRequest, index) in holidayRequests.results" :key="index">
                            <th scope="row">
                              <!-- {{ index + 1 }} -->
                              {{
                                holidayRequests.current_page * perPage -
                                perPage +
                                index +
                                1
                              }}
                            </th>

                            <td>
                              {{ holidayRequest.person_full_name }}
                            </td>

                            <td>
                              {{ holidayRequest.person_department }}
                            </td>
                            <td>{{ holidayRequest.role_name }}</td>

                            <td>{{ holidayRequest.relationship_name }}</td>
                            <td>{{ holidayRequest.created_at }}</td>
                            <td>{{ dateFormat(holidayRequest.start_date) }} - {{ dateFormat(holidayRequest.end_date) }}
                            </td>
                            <td>{{ holidayRequest.total_holiday_days }}</td>
                            <td> {{ holidayRequest.oracle_leave_type != null ?
                              holidayRequest.oracle_leave_type.leave_type :
                              holidayRequest.holiday_type_title }}</td>
                            <td>
                              <span :class="`badge bg-${statusVariant(holidayRequest.status)} font-size-13`">
                                {{ transStatus(holidayRequest.status) }}
                              </span>
                            </td>

                            <td v-if="holidayRequest.status === 'pending'">
                              <b-button variant="warning" size="sm" pill
                                v-b-modal="`modalRequest${holidayRequest.id}`"><i class="mdi mdi-pencil"></i></b-button>
                            </td>

                            <b-modal :id="'modalRequest' + holidayRequest.id" centered hide-footer
                              :ref="'modalRequest' + holidayRequest.id">
                              <request-holiday-modal :holidayRequest="holidayRequest"
                                @updatedStatus="updatedStatus"></request-holiday-modal>
                            </b-modal>
                          </tr>
                        </tbody>
                      </table>

                    </div>

                    <div class="row">
                      <div class="col">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination pagination-rounded mb-0" v-if="holidayRequests.results">
                            {{
                              holidayRequests.results.count
                            }}
                            <!-- pagination -->
                            <b-pagination v-model="currentPage" :total-rows="holidayRequests.count"
                              :per-page="perPage"></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import session from "../../../../api/session";
import { mapState, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import moment from "moment";
import requestHolidayModal from "./requestHolidayModal.vue";
export default {
  page: {
    title: "Αιτήσεις",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect, requestHolidayModal },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const isSupervisor = vm.$store.getters["auth/is_supervisor"];
      const hasEntityGroups = vm.$store.getters["auth/has_entity_groups"];
      const hasRoleAbove = vm.$store.getters["auth/has_role_above"];
      const hasHolidayModule = vm.$store.getters['auth/has_holiday_module'];
      const isSuperuser = vm.$store.getters["auth/is_superuser"];
      if (!hasHolidayModule) return next({ name: "home" });
      if (hasEntityGroups && !(isSupervisor || isSuperuser)) {
        return next({ name: "home" });
      }
      if (!hasEntityGroups && !hasRoleAbove) {
        return next({ name: "home" });
      }
      next();
    });
  },
  data() {
    return {
      title: "Αιτησεις",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Προσωπικό",
          active: true,
        },
      ],
      holidayRequests: [],
      perPage: 10,
      currentPage: 1,
      departmentValue: "",
      roleValue: "",
      relationShipValue: "",
      searchFilter: "",
      filters: {
        departments: [],
        relationships: [],
        roles: [],
        page: 1,
      },
      modalRequestIsOpen: false,
      is_tree: null,
    };
  },
  mounted() {
    this.fetchHolidayRequests();
  },
  watch: {
    currentPage(value) {
      this.filters.page = value;
      this.fetchHolidayRequests();
    },
    departmentValue(value) {
      this.filters.departments = value.length > 0 ? value.map((e) => e.id) : [];
      this.filters.page = 1;
      this.currentPage = 1;
      this.fetchHolidayRequests();
    },
    relationShipValue(value) {
      this.filters.relationships =
        value.length > 0 ? value.map((e) => e.id) : [];
      this.filters.page = 1;
      this.currentPage = 1;
      this.fetchHolidayRequests();
    },
    roleValue(value) {
      this.filters.roles = value.length > 0 ? value.map((e) => e.id) : [];
      this.filters.page = 1;
      this.currentPage = 1;
      this.fetchHolidayRequests();
    },
  },

  computed: {
    ...mapGetters("auth", ["userLoggedIn", "is_staff", "is_superuser", "has_holiday_module", "is_supervisor", "has_entity_groups", "has_role_above"]),
    ...mapState("utils", [
      "devices",
      "employmentRelationShips",
      "standarRoles",
      "roles",
      "departmentOptions",
      "roleChoices",
      "departments",
    ]),
    departmentNames() {
      return this.departmentOptions.map((e) => {
        return { id: e.id, name: e.department_parent_name };
      });
    },
    roleOptions() {
      return this.roleChoices
        .filter((e) => {
          return this.roles.map((r) => r.role).includes(e.role_id);
        })
        .map((role) => {
          return { id: role.role_id, name: role.role_name };
        });
    },
  },
  methods: {
    fetchHolidayRequests() {
      const searchParams = new URLSearchParams();
      this.filters.departments.forEach((id) => {
        searchParams.append("department", id);
      });
      this.filters.relationships.forEach((id) => {
        searchParams.append("relationship", id);
      });
      this.filters.roles.forEach((id) => {
        searchParams.append("role", id);
      });
      searchParams.append("person_name", this.searchFilter);
      searchParams.append("page", this.filters.page);

      session
        .get(`api/holiday-requests/?${searchParams.toString()}`)
        .then((resp) => {
          this.holidayRequests = resp.data;
        });
    },
    onSearchPerson() {
      this.currentPage = 1;
      this.filters.page = 1;
      this.fetchHolidayRequests();
    },
    transStatus(status) {
      const statusDict = {
        pending: "Εκκρεμής",
        approved: "Eγκρίθηκε",
        declined: "Aπορρίφθηκε",
      };
      return statusDict[status] || "-";
    },
    statusVariant(status) {
      const statusDict = {
        pending: "warning",
        approved: "success",
        declined: "danger",
      };
      return statusDict[status] || "primary";
    },
    dateFormat(date) {
      return moment(date).format("DD/MM/Y");
    },
    updatedStatus(id) {
      this.$bvModal.hide(`modalRequest${id}`);
      this.fetchHolidayRequests();
    },
    isEntity() {
      session.get(`api/industry/retrieve/`).then((resp) => {
        this.is_tree = !resp.data[0].has_entity_groups;
      });
    },
  },
  created() {
    this.isEntity();
  },
};
</script>